import * as t from 'io-ts'
import { Option } from 'fp-ts/lib/Option'

import { Org as TsApiOrg } from '@espoon-voltti/org-ts-api'
import { NuoraOrg, DraftNuoraOrg } from './nuora-org'

// It's better that domain code depends on ts-lib's (dto-like) types via this exporter:
// - easier maintenance if our domain chooses to extend types at some point
// - it might be possible to create a linter rule that this exporter is the only domain module
//   that is allowed to directly depend on '@espoon-voltti/org-ts-api'
export { Area, Representative } from '@espoon-voltti/org-ts-api'

export interface OrgAttachment {
  name: string
  path: string
  version: Option<string>
}

export const DraftOrg = t.type({ id: t.string })
export type DraftOrg = t.TypeOf<typeof DraftOrg>

// NuorA doesn't store modifiedAt and modifiedBy in the org snapshot
export interface Org
  extends Omit<TsApiOrg, 'attachments' | 'modifiedAt' | 'modifiedBy'> {
  attachments: OrgAttachment[]
}

export interface OrgApplicant {
  type: 'ORGANISATION'
  org: Org
  nuoraOrg: NuoraOrg
}

export interface DraftOrgApplicant {
  type: 'ORGANISATION'
  org: Org
  nuoraOrg: DraftNuoraOrg
}
